// In userQuery.ts — add if not present
export const getUserQuery = `
  query GetUser($input: GetUserInput!) {
    getUser(input: $input) {
      code
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
